import React, {useState} from 'react'
import {bindActionCreators, compose} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import AppDialog from "../components/dialog/appdialog";
import {SESS_EXPIRED_TEXT, SESS_EXPIRED_TITLE} from "@app/common/constants/constants";
import {
    loadAccess,
    loadLevel,
    loadSession,
    loadSessionExpired,
    loadUser,
    setLoading,
    unloadSession
} from "@app/common/store/action";
import {LOGIN_ROUTE} from "../constants/routeconstants";
import {logoutService} from "@app/common/services/logoutservice";

function AuthenticationHOC(props){
    const [isOpen,setIsOpen] = useState(false);

    const {sessionExpiry,location} = props;

    const handleDialogClose = ()=>{
        clearSession();
        props.history.push(LOGIN_ROUTE)
    }
    const clearSession = ()=>{
        const {actions} = props;
        actions.loadSessionExpired(false)
        actions.unloadSession()
    }
    const logoutSession = async()=>{
        await logoutService()
    }
    return (
        <section>
            {sessionExpiry ?
                <AppDialog title={SESS_EXPIRED_TITLE} text={SESS_EXPIRED_TEXT}
                           isOpen={sessionExpiry}
                           requestActionHandler={handleDialogClose}
                           callback={logoutSession}/>

                : props.children}
        </section>
    )
}

const mapStateToProps = (state, ownProps) => ({
    sessionExpiry:state.sessionExpiry

});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { unloadSession,loadSessionExpired},
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(AuthenticationHOC)
